import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { AuthProvider } from "./provider/AuthProvider";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://deb708254088cd0c79fa531c4f978070@o4508959934709760.ingest.us.sentry.io/4508960009682944",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // 100% of transactions for performance monitoring
  tracePropagationTargets: [
    "staging1.helpmatch.com",
    "helpmatch.com",
    /^https:\/\/staging1\.helpmatch\.com/,
    /^https:\/\/helpmatch\.com/,
  ],
  // Session Replay
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <AuthProvider>
      <App />
      
    </AuthProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
